export default __webpack_public_path__ + "static/media/Background.5b865da0.svg";